import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Table, Button, Form, Input, Spin, Space, DatePicker } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, UploadOutlined } from '@ant-design/icons';
import Message from '../../component/message/message';
import moment from 'moment';//日期格式化导包
import PopupFrame from '../../component/popupFrame/popupFrame';
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import trans from './translation';
import './cohort.css';
import UploadModal from './uploadModal';
import { searchCohortYear } from '../../system/login/login'
const { TabPane } = Tabs;
const Cohort = (props) => {
    const [form] = Form.useForm();
    const [form2] = Form.useForm();

    const messageRef = useRef();
    const [tabIndex, setTabIndex] = useState("1");
    const [checkboxState, setCheckboxState] = useState([]);
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});

    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [groupMemberTables, setGroupMemberTables] = useState([]);
    const [isUpload, setIsUpload] = useState(false);
    const [cohortYearModel, setCohortYearModel] = useState({});
    const [cohortYear, setCohortYear] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const [isClone, setIsClone] = useState(false);
    const tableColumns = {
        cohortYear: "cohortYear",
    }

    useEffect(() => {
        search(pageSize, 1, "N");
    }, []);

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else if ("reset" === flag) {
            model = {}
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        setCohortYear(model.cohortYear)
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("cohort/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const reset = () => {
        messageShowHandler();
        form2.resetFields();
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
        setSearchModel({})
    }

    const checkEndDate = (value) => {
        const end = moment(value);
        const start = form.getFieldValue('startDate')
        if (Base.isEmpty(form.getFieldValue('endDate'))) {
            return Promise.reject("To Date is required.")
        }
        if (!!value && !!start) {
            if (start.isAfter(end)) {
                return Promise.reject("To Date cannot be earlier than From Date.")
            }
        }
        return Promise.resolve();
    }
    const checkStartDate = (value) => {
        const end = moment(value);
        const start = form.getFieldValue('endDate')
        if (Base.isEmpty(form.getFieldValue('startDate'))) {
            return Promise.reject("From Date is required.")
        }
        if (!!value && !!start) {
            if (end.isAfter(start)) {
                return Promise.reject("From Date cannot be later than To Date. ")
            }
        }
        return Promise.resolve();
    }


    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (checkboxState.length === 1 && Config.funcInfo.canUpdate === "Y") {
                    edit();
                } else if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({});
        setGroupMemberTables([]);
        setFlag("add");
        setTabIndex("2");
    }
    const download = () => {
        setIsUpload(true)
    }

    const update = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        messageShowHandler();
        searchById(model.cohortId)
        setTabIndex("2");
        setFlag("edit");
    }

    const clone = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        messageShowHandler();
        searchCloneById(model.cohortId)
        setTabIndex("2");
        setFlag("clone");

    }
    const edit = () => {
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            cohortYear: model.cohortYear ?? '',
            cohortDesc: model.cohortDesc ?? "",
            startDate: model.startDate ? moment(moment(model.startDate).format(Config.dateFormat5), Config.dateFormat5) : null,
            endDate: model.endDate ? moment(moment(model.endDate).format(Config.dateFormat5), Config.dateFormat5) : '',
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let deleteModel = cohortYearModel;
        deleteModel.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("cohort/delete", deleteModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                cancel();
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
                searchCohortYear()
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const onFinish = (values) => {
        messageShowHandler();
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        if (!values.endDate) {
            values.endDate = null
        }
        let url = "";
        if (flag === "add") {
            url = "cohort/insert";
        } else if (flag === 'edit') {
            url = "cohort/update"
            values.cohortId = cohortYearModel.cohortId;
            values.lastUpdatedDate = cohortYearModel.lastUpdatedDate;
        } else if (flag === 'clone') {
            url = "cohort/clone"
            values.cohortId = cohortYearModel.cohortId;
            values.lastUpdatedDate = cohortYearModel.lastUpdatedDate;
        }
        values.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi(url, values).then((data) => {
            if ("SUCCESS" === data.msg) {
                searchById(data.object)
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
                searchCohortYear()
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false);
        });
    }

    const searchById = (model) => {
        setIsLoading(true);
        Base.callBackApi("cohort/searchById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let cohortYearModel = data.object;
                initForm(cohortYearModel);
                setCohortYearModel(cohortYearModel)
                setFlag("edit");
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoading(false));
    }

    const searchCloneById = (model) => {
        setIsLoading(true);
        Base.callBackApi("cohort/searchById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let cohortYearModel = data.object;
                initForm(cohortYearModel);
                setCohortYearModel(cohortYearModel)
                setFlag("clone");
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoading(false));
    }

    const cancel = () => {
        messageShowHandler();
        setGroupMemberTables([]);
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    const deleteOne = (model, e, type) => {
        e.stopPropagation();
        setCohortYearModel(model)
        setIsDeleteFrame(true);
        if (type == "segment") {
            setDeleteTipText("Cohort" + ":" + model.cohortYear + "")
        }
    }


    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }


    const uploadClose = (flag) => {
        setIsUpload(false);
    }

    const validateYear = (rule, value) => {
        if (!value) {
            return Promise.reject(trans.cohortYearNoIsNull[Config.backLang]);
        }
        const regex = /^\d{2}\/\d{2}$/;
        if (!regex.test(value)) {
            return Promise.reject('Please input cohort in correct format: YY/YY (e.g.: 23/24)');
        }
        return Promise.resolve();
    };

    /*eslint-disable*/
    const columns = [

        {
            title: 'Cohort',
            dataIndex: 'cohortYear',
            className: 'tableWidth20',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'cohortYear') },
        },
        {
            title: 'From Date',
            dataIndex: 'startDate',
            className: 'tableWidth40',
            render: (text) => text != null ? moment(text).format(Config.dateFormat5) : null
        },
        {
            title: 'To Date',
            dataIndex: 'endDate',
            className: 'tableWidth40',
            render: (text) => text != null ? moment(text).format(Config.dateFormat5) : null
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            className: ' sysControls',
            fixed: 'right',
            width: 206,
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e, "segment")} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];

    return (
        <div id="container" className="template cohort">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <Form form={form2} >
                                <div className='sysSearchRow sysSearchBox'>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysTitle">{trans.cohortYear[Config.backLang]}</div>
                                            <div className="sysSerchInput">
                                                <Form.Item
                                                    name="cohortYear"
                                                >
                                                    <Input type="text" value={searchModel.cohortYear || ''}
                                                        placeholder={trans.cohortYear[Config.backLang]}
                                                        onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                        onChange={(e) => searchChange('cohortYear', e.target.value)} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysSearchButton'>
                                            <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                            <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button type="primary" className="sysBtn btnBlue" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                                {tables.length == 0 ? null :
                                    <>
                                        <Button type="primary" className="sysBtn btnBlue" onClick={download} hidden={Config.funcInfo.canInsert === "N"} icon={<UploadOutlined />}>{trans.batchUpload[Config.backLang]}</Button>
                                    </>
                                }
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 1000 }}
                                    rowKey="cohortId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,                        //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,        //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,                //当前页
                                        pageSize: pageSize,              //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={trans.cohort[Config.backLang]} forceRender={true}>
                            <Form form={form} onFinish={onFinish}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">{trans.cohortYear[Config.backLang]}</div>
                                        <div className="sysInput ">
                                            <Form.Item
                                                name="cohortYear"
                                                rules={[
                                                    // { required: true},
                                                    { validator: validateYear },
                                                ]}
                                            >
                                                <Input type="text" placeholder={trans.cohortYear[Config.backLang]} maxLength={5} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput ">{trans.cohortDesc[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="cohortDesc"

                                            >
                                                <Input type="text" placeholder={trans.cohortDesc[Config.backLang]} maxLength={40} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">From Date</div>
                                        <div className="sysInput ">
                                            <Form.Item
                                                name="startDate"
                                                rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                                    { validator: (rule, value) => checkStartDate(value) },
                                                ]}
                                            >
                                                <DatePicker placeholder="From Date" />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">To Date</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="endDate"
                                                rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                                    { validator: (rule, value) => checkEndDate(value) },
                                                ]}
                                            >
                                                <DatePicker placeholder="To Date" />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit">{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
            {isUpload && <UploadModal onClose={uploadClose} />}
        </div>
    )

}

export default Cohort;